<mat-toolbar
	class="mat-elevation-z4 z-2"
	color="primary"
	fxLayout
	fxLayoutGap="16px"
	fxLayoutAlign="start center"
>
	<button mat-icon-button (click)="sideNavToggle.emit()">
		<mat-icon>menu</mat-icon>
	</button>
	<img
		src="../../../admin-assets/RailPros-Logo.png"
		width="400"
		height="45"
	/>
</mat-toolbar>
